module.exports = __webpack_public_path__ + "static/media/Header-bg-tablet-@2x.443e8a68.png";